import {cs}                from "@Common/react/chain-services";
import {consumeContext}    from "@Common/react/context";
import {scopedState}       from "@Common/react/scoped-state";
import {UseState}          from "@Common/react/use-state";
import {setCurrentToSaved} from "@Common/ui-components/heavy/item-options/modules/set-current-to-saved";
import {changeNestedValue, getNestedValue, setNestedValue} from "@Common/utils/arr-path";
import {chain}             from "@Common/utils/fs";
import {equalDeep, omit}              from "@Common/utils/objects";

export const YardSignLogic = (
    {
        item,
        templateOptions,
        sequence,
        state,
        next: rootNext,
    }
) => cs(
    consumeContext('apis'),
    ["optionState", (_, next) => next(scopedState(state, [sequence, "selections", "options"]))],
    // UseState({
        //     getInitValue: () => chain(
            //         item?.components?.[sequence]?.options?.find((o) => o.group === "YARD SIGN OPTIONS")?.dev_key,
            //         (_) => ({
                //             saved  : _,
                //             current: _,
                //         }),
                //     ),
                //     next,
                // })],
    ["step1", ({}, next) => rootNext({
        cleanItem: (item) => changeNestedValue(item, ["components", sequence, "selections", "options"], (_) => _?.filter((o) =>
            o.group !== "YARD SIGN OPTIONS"
        )),
        next,
    })],
    ({optionState, step1,apis}) => step1.next(cs(

        ({}, next) => ["mailing", "shipping", "pickup"].includes(step1.method) && next(),


        ["yardSignOptions", (_, next) => next(templateOptions.options.filter((o) => o.group === "YARD SIGN OPTIONS"))],
        ["devKey", (_,next) => next(optionState?.value?.find((o) => o?.group === "YARD SIGN OPTIONS")?.dev_key)],
        ["calSelected", ({yardSignOptions, devKey}, next) => next(!devKey ? null : (
            yardSignOptions.find((o) => o.dev_key === devKey)
        ))],
        ({calSelected, yardSignOptions}) => ({
            ui: yardSignOptions[0] && {
                yardSignOptions,
                calSelected,
                optionState,
                calOptionSet: async (value, name) => {
                    const updatedState = chain(
                        state,
                        (state) => state.value,
                        (state) => value ? (
                            getNestedValue(state, [sequence, "selections", "options"]) ? (
                                changeNestedValue(state, [sequence, "selections", "options"], (_) => [
                                    ..._?.filter((o) => o.group != "YARD SIGN OPTIONS"),
                                    {
                                        "group": "YARD SIGN OPTIONS",
                                        "dev_key": value,
                                        "name": name,
                                    },
                                ])
                            ) : (
                                setNestedValue(state, [sequence, "selections", "options"], [
                                    {
                                        "group": "YARD SIGN OPTIONS",
                                        "dev_key": value,
                                        "name": name,
                                    },
                                ])
                            )
                        ) : (
                            getNestedValue(state, [sequence, "selections", "options"]) ? (
                                changeNestedValue(state, [sequence, "selections", "options"], (_) => ([
                                    ..._?.filter((o) => o.group != "YARD SIGN OPTIONS"),
                                ]))
                            ) : state
                        ),
                    );
                    if(!equalDeep(updatedState, state.value))
                    {
                        state.onChange(updatedState);
                    }
                }
            },
        }),
    )),
);